import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Loader from './Loader';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requirePayment?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requirePayment = false }) => {
    const { user, userProfile, loading } = useAuth();

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '100vh',
                background: '#ffffff'
            }}>
                <Loader />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    // NOTE: We intentionally DO NOT redirect unpaid users away from /dashboard.
    // The dashboard renders its own paywall view (`ui.states.paywall_*`), which
    // is a better UX than bouncing the user back into the quiz funnel - they
    // get a clear "what is this and how do I unlock it" screen instead of a
    // surprise redirect. The `requirePayment` prop is kept on the route for
    // documentation purposes; gating happens inside DashboardPage now.
    if (requirePayment && !userProfile) {
        // Still wait for profile resolution; gating is up to the page.
    }

    return children as React.ReactElement;
};

export default ProtectedRoute;

